import { render, staticRenderFns } from "./CodeM.vue?vue&type=template&id=ea50460e&scoped=true"
import script from "./CodeM.vue?vue&type=script&lang=js"
export * from "./CodeM.vue?vue&type=script&lang=js"
import style0 from "./CodeM.vue?vue&type=style&index=0&id=ea50460e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea50460e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea50460e')) {
      api.createRecord('ea50460e', component.options)
    } else {
      api.reload('ea50460e', component.options)
    }
    module.hot.accept("./CodeM.vue?vue&type=template&id=ea50460e&scoped=true", function () {
      api.rerender('ea50460e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/CodeM.vue"
export default component.exports